import { socketMessageKinds } from "@specsheet-common/shared-types";
import { Socket } from "socket.io-client";
import { Listeners, Subscriptions } from "./types";

interface UseSubscriptionProps {
  socket?: Socket;
  listeners: Listeners;
  setIsWaitingForMessage(data: boolean): void;
  setIsWaitingForDocumentDownloadMessage(
    setState: (data: {
      campaign: boolean;
      placement: boolean;
      placementOne: boolean;
    }) => {
      campaign: boolean;
      placement: boolean;
      placementOne: boolean;
    }
  ): void;
}

export const useSubscriptions = ({
  socket,
  listeners,
  setIsWaitingForMessage,
  setIsWaitingForDocumentDownloadMessage,
}: UseSubscriptionProps): Subscriptions => {
  return {
    [socketMessageKinds.campaignVersionReportFileReady]: {
      subscribe: (callback) => {
        socket?.once(
          socketMessageKinds.campaignVersionReportFileReady,
          (data) =>
            listeners[socketMessageKinds.campaignVersionReportFileReady](
              data,
              callback
            )
        );
      },
      unsubscribe: () => {
        socket?.off(
          socketMessageKinds.campaignVersionReportFileReady,
          listeners[socketMessageKinds.campaignVersionReportFileReady]
        );
        setIsWaitingForMessage(false);
      },
    },
    [socketMessageKinds.contractVariationReportFileReady]: {
      subscribe: () => {
        socket?.on(
          socketMessageKinds.contractVariationReportFileReady,
          (data) =>
            listeners[socketMessageKinds.contractVariationReportFileReady](data)
        );
      },
      unsubscribe: () => {
        socket?.off(
          socketMessageKinds.contractVariationReportFileReady,
          listeners[socketMessageKinds.contractVariationReportFileReady]
        );
        setIsWaitingForMessage(false);
      },
    },
    [socketMessageKinds.userUpdated]: {
      subscribe: (callback) => {
        socket?.on(socketMessageKinds.userUpdated, () =>
          listeners[socketMessageKinds.userUpdated](callback)
        );
      },
      unsubscribe: (callback) => {
        socket?.off(socketMessageKinds.userUpdated, () =>
          listeners[socketMessageKinds.userUpdated](callback)
        );
        setIsWaitingForMessage(false);
      },
    },
    [socketMessageKinds.campaignAllDocumentsZipFileReady]: {
      subscribe: () => {
        socket?.on(
          socketMessageKinds.campaignAllDocumentsZipFileReady,
          listeners[socketMessageKinds.campaignAllDocumentsZipFileReady]
        );
      },
      unsubscribe: () => {
        socket?.off(
          socketMessageKinds.campaignAllDocumentsZipFileReady,
          listeners[socketMessageKinds.campaignAllDocumentsZipFileReady]
        );
        setIsWaitingForDocumentDownloadMessage((preState) => ({
          ...preState,
          campaign: false,
        }));
      },
    },
    [socketMessageKinds.placementAllDocumentsZipFileReady]: {
      subscribe: () => {
        socket?.on(
          socketMessageKinds.placementAllDocumentsZipFileReady,
          listeners[socketMessageKinds.placementAllDocumentsZipFileReady]
        );
      },
      unsubscribe: () => {
        socket?.off(
          socketMessageKinds.placementAllDocumentsZipFileReady,
          listeners[socketMessageKinds.placementAllDocumentsZipFileReady]
        );
        setIsWaitingForDocumentDownloadMessage((preState) => ({
          ...preState,
          placement: false,
        }));
      },
    },
    [socketMessageKinds.placementOneDocumentsZipFileReady]: {
      subscribe: () => {
        socket?.on(
          socketMessageKinds.placementOneDocumentsZipFileReady,
          listeners[socketMessageKinds.placementOneDocumentsZipFileReady]
        );
      },
      unsubscribe: () => {
        socket?.off(
          socketMessageKinds.placementOneDocumentsZipFileReady,
          listeners[socketMessageKinds.placementOneDocumentsZipFileReady]
        );
        setIsWaitingForDocumentDownloadMessage((preState) => ({
          ...preState,
          placementOne: false,
        }));
      },
    },
    [socketMessageKinds.campaignVisitorsUpdated]: {
      subscribe: (callback) => {
        socket?.on(socketMessageKinds.campaignVisitorsUpdated, (message) =>
          listeners[socketMessageKinds.campaignVisitorsUpdated](
            message,
            callback
          )
        );
      },
      unsubscribe: () => {
        socket?.off(
          socketMessageKinds.campaignVisitorsUpdated,
          listeners[socketMessageKinds.campaignVisitorsUpdated]
        );
      },
    },
    [socketMessageKinds.applicationVersion]: {
      subscribe: (callback) => {
        socket?.on(socketMessageKinds.applicationVersion, (message) =>
          listeners[socketMessageKinds.applicationVersion](message, callback)
        );
      },
      unsubscribe: () => {
        socket?.off(
          socketMessageKinds.applicationVersion,
          listeners[socketMessageKinds.applicationVersion]
        );
      },
    },
  };
};
